import { render, staticRenderFns } from "./StoreApplys.vue?vue&type=template&id=22c216c9&scoped=true&"
import script from "./StoreApplys.vue?vue&type=script&lang=js&"
export * from "./StoreApplys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c216c9",
  null
  
)

export default component.exports